import {
  EmojiEvents as TrophyIcon,
  Campaign as PromoIcon,
  SportsEsports as GameIcon,
  CardGiftcard as PrizeIcon,
  MilitaryTech as FameIcon,
} from "@mui/icons-material";

export const widgetOptions = [
  {
    type: "coins-winners-ticker",
    name: "Coins Winners Ticker",
    icon: <TrophyIcon fontSize="small" />,
  },
  {
    type: "ultimate-fan",
    name: "Ultimate Fan",
    icon: <TrophyIcon fontSize="small" />,
  },
  {
    type: "promo-carousel",
    name: "Promo Carousel",
    icon: <PromoIcon fontSize="small" />,
  },
  {
    type: "mini-game-section-box",
    name: "Mini Game Section Box",
    icon: <GameIcon fontSize="small" />,
  },
  {
    type: "mini-game-section-vert",
    name: "Mini Game Section Vert",
    icon: <GameIcon fontSize="small" />,
  },
  {
    type: "mini-game-section-full",
    name: "Mini Game Section Full Box",
    icon: <GameIcon fontSize="small" />,
  },
  {
    type: "mini-game-section-big",
    name: "Mini Game Section Big Box",
    icon: <GameIcon fontSize="small" />,
  },
  {
    type: "mini-game-section-feature",
    name: "Mini Game Section Feature",
    icon: <GameIcon fontSize="small" />,
  },
  {
    type: "prize-draw-active",
    name: "Prize Draw: Active",
    icon: <PrizeIcon fontSize="small" />,
  },
  {
    type: "prize-draw-winner",
    name: "Prize Draw: Winner",
    icon: <PrizeIcon fontSize="small" />,
  },
  {
    type: "hall-of-fame",
    name: "Hall of Fame",
    icon: <FameIcon fontSize="small" />,
  },
  {
    type: "advert-box",
    name: "Advert Box",
    icon: <FameIcon fontSize="small" />,
  },
  {
    type: "advert-half-box",
    name: "Advert Half Box",
    icon: <FameIcon fontSize="small" />,
  },
  {
    type: "advert-banner",
    name: "Advert Banner",
    icon: <FameIcon fontSize="small" />,
  },
];
